import { render, staticRenderFns } from "./SurveyPublicTake.vue?vue&type=template&id=197f9e5f&scoped=true"
import script from "./SurveyPublicTake.vue?vue&type=script&lang=js"
export * from "./SurveyPublicTake.vue?vue&type=script&lang=js"
import style0 from "./SurveyPublicTake.vue?vue&type=style&index=0&id=197f9e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f9e5f",
  null
  
)

export default component.exports